import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__/index.ts';
import { ProfileStreamsQuery } from '@/routes/_app.$username._index/loader.ts';
import { useAuthInfo } from '@/routes/_app/use-auth-info.ts';

const PUBLISH_STREAM = gql(`
  mutation PublishStream($id: ID!) {
    publishStream(id: $id) {
      id
      streamState
    }
  }
`);

export const usePublishStream = (id: string) => {
  const toast = useToast();
  const authInfo = useAuthInfo();

  const [publishStreamMutation, result] = useMutation(PUBLISH_STREAM, {
    onError: () => {
      toast.error({
        title: 'Failed to publish stream',
        subTitle: 'Please try again',
      });
    },

    refetchQueries: [
      {
        query: ProfileStreamsQuery,
        variables: { username: authInfo.username, limit: 10, nextToken: null },
      },
    ],
  });

  const publishStream = () => {
    return publishStreamMutation({
      variables: {
        id,
      },
    });
  };

  return [publishStream, result] as const;
};
